// Espelho de TipoExibicaoSecaoPedidoEnum da ATS.Hub.API.Vendas (lookup tipo_exibicao_secao_pedido):
// como cada secao configuravel do Pedido de Venda aparece (story §3).
//   Sim ............... renderizada e aberta
//   Nao ............... nao renderizada, e seus campos nao entram em validacao nenhuma
//   ExibirRecolhido ... renderizada fechada; abre por clique e mantem o estado na sessao
export enum TipoExibicaoSecaoPedidoEnum {
    Sim = 1,
    Nao = 2,
    ExibirRecolhido = 3,
}
